<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <a-layout-sider v-model="collapsed" :trigger="null" collapsible :style="styleObject">
      <div
        class="logo narrow"
        style="overflow: hidden; align-item: center"
        title="Version 1.1.0902.01"
      >
        <img src="../assets/logo.png" style="margin: 0px; margin-left: 10px" alt="" />
        <h1 v-if="!collapsed" style="color: #fff; margin: 0px; margin-left: 10px;font-size: 16px;">
          {{ $t("sysTitle") }}
        </h1>
      </div>
      <sidemenu />
    </a-layout-sider>
    <a-layout :style="{ marginLeft: '0px', minWidth: '1300px' }">
      <a-layout-header
        style="
          height: 50px;
          line-height: 50px;
          background: #fff;
          padding: 0px;
          display: flex;
          justify-content: space-between;
        "
      >
        <!-- 面包屑 -->
        <div class="left-wrap">
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="toggleCollapsed"
          />
          <a-tabs
            :activeKey="currentTabKey"
            hide-add
            type="editable-card"
            style="align-items: center; margin-top: 10px"
            :tabBarStyle="{
              display: 'flex',
              margin: '0px',
              borderBottom: 'none',
            }"
            @tabClick="handleClick"
            @edit="onEdit"
            @change="handleChange"
          >
            <a-tab-pane v-for="item in tabList" :key="item.path" :tab="item.title">
            </a-tab-pane>
          </a-tabs>
        </div>

        <div class="rightwrap">
          <!-- 显示登陆用户信息及修改密码 -->
          <template>
            <a-popover title="" trigger="hover">
              <a slot="content" @click="shouModifyModal" style="width: 150px">{{
                $t("changePassword")
              }}</a>
              <a-modal
                :title="$t('changePassword')"
                v-model="visible_modal"
                @cancel="cancelModal"
              >
                <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
                  <a-form-item :label="$t('oldPassword')">
                    <a-input
                      allowClear
                      style="width: 180px"
                      v-model.trim="modifyPassword.oldPassword"
                      :placeholder="$t('oldPassword')"
                    >
                    </a-input>
                  </a-form-item>
                </a-form>
                <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
                  <a-form-item :label="$t('newPassword')">
                    <a-input
                      allowClear
                      style="width: 180px"
                      v-model.trim="modifyPassword.newPassword"
                      :placeholder="$t('newPassword')"
                    >
                    </a-input>
                  </a-form-item>
                </a-form>
                <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
                  <a-form-item :label="$t('confirmNewPassword')">
                    <a-input
                      allowClear
                      style="width: 180px"
                      v-model.trim="modifyPassword.confirmNewPassword"
                      :placeholder="$t('confirmNewPassword')"
                    >
                    </a-input>
                  </a-form-item>
                </a-form>
                <template slot="footer" class="footer">
                  <a-button
                    key="submit"
                    type="primary"
                    :loading="confirmLoading"
                    @click="okModify"
                  >
                    {{ $t("sure") }}
                  </a-button>
                  <a-button key="back" @click="resetInput">
                    {{ $t("reset") }}
                  </a-button>
                </template>
              </a-modal>
              <a-button
                type="link"
                class="userinfo"
                style="background: white; color: #1890ff; border: none; font-size: 14px"
              >
                {{ currentUser.companyName }}&nbsp;&nbsp;-&nbsp;&nbsp;{{
                  currentUser.name
                }}
              </a-button>
            </a-popover>
          </template>

          <!-- 国际化 -->
          <LocaleSelect style="margin-right: 10px" />

          <!-- 退出登录按钮 -->
          <a-button type="primary" class="logout" @click="logout">
            {{ $t("logOut") }}
          </a-button>
        </div>
      </a-layout-header>
      <a-layout-content
        style="background: #eee; paddingtop: 15px; width: 100%; height: 100%"
      >
        <template>
          <a-card style="width: 100%; height: 100%">
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </a-card>
        </template>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import { mapMutations } from "vuex";
import sidemenu from "./sidemenu.vue";
import LocaleSelect from "./LocaleSelect.vue";
import { searchReqParam } from "../utils/searchReqParam";
import { updatePassword, currentUserInfo } from "../api/update-password";
import store from "../store";

export default {
  name: "index",
  props: {},
  components: { sidemenu, LocaleSelect },
  data() {
    return {
      name: "",
      breadList: [],
      collapsed: false,
      visible: false,
      visible_modal: false,
      confirmLoading: false,
      req: searchReqParam(),
      modifyPassword: {
        confirmNewPassword: undefined,
        currentUserId: "",
        newPassword: undefined,
        oldPassword: undefined,
      },
      currentUser: {
        companyName: "",
        name: "",
      },
      localeWidthMapp: {
        zh_CN: 160,
        en_US: 230,
        vi_VN: 230,
      },
      width: 220,
    };
  },
  computed: {
    styleObject() {
      return {
        maxWidth: this.width + "px !important",
        minWidth: this.width + "px !important",
        flex: "0 0 " + this.width + "px !important",
        width: this.width + "px !important",
      };
    },
    currentTabKey() {
      return store.getters.getCurrentTabKey;
    },
    tabList() {
      return store.getters.getPageTabs;
    },
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    toggleCollapsed() {
      if (this.collapsed) {
        this.width = this.localeWidthMapp[window.localStorage.getItem("locale")] || 220;
      } else {
        this.width = 80;
      }
      this.collapsed = !this.collapsed;
    },
    logout() {
      window.localStorage.removeItem("locale");
      this.$router.push("/login");
      window.localStorage.removeItem("userInfo");
      window.localStorage.removeItem("autologin_user");
      location.reload();
    },
    getBreadcrumb() {
      this.breadList = [];
      this.name = this.$route.name;
      this.$route.matched.forEach((item) => {
        this.breadList.push(item);
      });
    },
    cancelModal() {
      this.visible_modal = false;
      this.resetInput();
    },
    shouModifyModal() {
      this.visible_modal = true;
    },
    okModify() {
      // console.log("=====okModify====", this.modifyPassword);
      // console.log(this.req);
      if (
        this.modifyPassword.oldPassword == "" ||
        this.modifyPassword.oldPassword == undefined
      ) {
        this.$message.error(this.$t("businessDispatch.passwordIsNotEmpty"));
        return;
      }
      if (
        this.modifyPassword.newPassword == "" ||
        this.modifyPassword.newPassword == undefined
      ) {
        this.$message.error(this.$t("businessDispatch.newPasswordIsNotEmpty"));
        return;
      }
      if (
        this.modifyPassword.confirmNewPassword == "" ||
        this.modifyPassword.confirmNewPassword == undefined
      ) {
        this.$message.error(this.$t("businessDispatch.verifyPasswordIsNotEmpty"));
        return;
      }
      // 新增确认密码校验正确及密码强度校验
      if (this.modifyPassword.newPassword != this.modifyPassword.confirmNewPassword) {
        this.$message.error(this.$t("businessDispatch.passwordsInconsistent"));
        return;
      }

      this.req.params = this.modifyPassword;
      updatePassword(this.req).then((res) => {
        console.log("updatePassword===========", res);
        let tempmsg = JSON.parse(res.data);
        console.log(tempmsg);
        if (tempmsg.code == "dat-PASSWORD_INCONSISTENT") {
          this.$message.error(this.$t("businessDispatch.oldPasswordIsWrong"));
        }
        if (tempmsg.code == "0") {
          this.$message.success(this.$t("businessDispatch.passwordHasBeenUpdated"));
          this.resetInput();
          this.visible_modal = false;
          this.$router.push("/login");
        }
      });
    },
    resetInput() {
      console.log("resetInput");
      this.modifyPassword = {
        confirmNewPassword: undefined,
        newPassword: undefined,
        oldPassword: undefined,
      };
    },
    onEdit(targetKey, action) {
      if (action === "remove") {
        if (!(this.tabList.length > 1)) {
          return;
        }
        if (targetKey == this.currentTabKey) {
          let index = this.tabList.findIndex((item) => item.path == targetKey);
          let brother = this.tabList[index + 1];
          if (!brother) {
            brother = this.tabList[index - 1];
          }
          this.$router.push(brother.path);
        }
        store.commit("removePageTab", targetKey);
      }
    },
    handleClick(obj) {
      console.log(obj);
    },
    handleChange(activeKey) {
      this.$router.push(activeKey);
    },
  },
  created() {
    this.width = this.localeWidthMapp[window.localStorage.getItem("locale")] || 220;
    this.getBreadcrumb();
    store.dispatch("initCurrencyList");
    currentUserInfo().then((res) => {
      let tempInfo = JSON.parse(res.data).data;
      if(tempInfo){

        window.localStorage.setItem('currentUserInfo',JSON.stringify({
          name: tempInfo.name,
          companyName: tempInfo.companyName
        }))
      } 
      this.currentUser.companyName = tempInfo.companyName;
      this.currentUser.name = tempInfo.name;
      this.setUserInfo(tempInfo);
      if (tempInfo.language !== this.$i18n.locale) {
        window.localStorage.setItem("locale", tempInfo.language);
       
        location.reload();
      }
    });
  },
  watch: {
    "$i18n.locale"(newV) {
      this.width = this.localeWidthMapp[newV] || 220;
    },
    $route() {
      this.getBreadcrumb();
    },
    tabList(list) {
      console.log(list, "fffffffffff");
    },
    currentTabKey(key) {
      console.log(key, "currentTabKey");
    },
  },
};
</script>

<style scope lang="less">
/* table 首列radio 列宽 */
.ant-table colgroup > col.ant-table-selection-col {
  width: 32px;
}
.ant-table-small > .ant-table-content > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-body > table,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-header
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table {
  border-bottom: 1px solid #e8e8e8;
}
#components-layout-demo-custom-trigger {
  height: 100%;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 56px;
  padding: 0 24px;
  cursor: pointer;
  float: left;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 50px;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
}
.ant-table-thead {
  background: #f5f5f5;
}
.ant-table-body-outer > .ant-table-body-inner > table {
  border: 1px solid #e9eaea !important;
}
.logout {
  margin-right: 40px;
}
.userinfo {
  margin-right: 20px;
}
.rightwrap {
  float: right;
}
.breadcrumb {
  float: left;
  margin-top: 15px;
}

.logo img {
  width: 120px;
}
.ant-menu .ant-menu-item {
  margin: 0;
  line-height: 40px;
  font-size: 14px;
}

.narrow img {
  height: 30px;
  width: 30px;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .ant-layout-content {
    width: 100%;
  }
  #components-layout-demo-custom-trigger {
    height: 100vh;
  }
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item,
.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 32px !important;
  line-height: 32px !important;
}
.ant-card-body {
  width: 100%;
  height: 100%;
  overflow: scroll;
  padding: 0;
}
.customer-list-form {
  display: flex;
  justify-content: left;
  padding: 10px 24px 0 24px;
}
.button-area {
  text-align: left;
  padding: 0px 24px;
}
.table-area {
  padding: 0px 24px;
}

//  基础数据 按钮区吸顶
.button-area {
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  display: flex;
  align-items: center;
}
.table-area {
  .ant-table-scroll {
    overflow: inherit;
  }
  .ant-table-body {
    overflow: inherit !important;
  }
  // 基础数据 表格区吸顶
  .ant-table-thead {
    position: sticky;
    top: 50px;
    background: #f5f5f5;
    z-index: 100;
  }
  // 去除 table 底部多出默认边框
  .ant-table-small.ant-table-bordered {
    border-bottom: 0;
  }
}
.table-area-active {
  .ant-table-thead {
    position: sticky;
    top: 50px;
    background: #f5f5f5;
    z-index: 100;
  }
}
.table-area-static {
  .ant-table-thead {
    position: static;
    top: 0px;
    background: #f5f5f5;
    z-index: 100;
  }
}

// 文字提示 tooltip 样式
.ant-tooltip-inner {
  min-width: 100px;
  white-space: break-spaces;
}
.popovername {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  white-space: break-spaces;
  // width: 200px;
  -webkit-box-orient: vertical;
}
.ant-select-row {
  background-color: #cbf2ff;
}

.left-wrap {
  position: relative;
  flex: 1;
}
</style>
